@if (showMainRoute()) {
  <h2>User Management</h2>
  @if (loading) {
    <div class="loading-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
  <kendo-grid class="grid-size" [kendoGridBinding]="gridView" [sortable]="true" [sort]="sort" [pageSize]="20" scrollable="none" [pageable]="true" [resizable]="true" [reorderable]="true" [navigable]="['table', 'pager']">
    <ng-template kendoGridToolbarTemplate>
      <!-- Search -->
      <kendo-textbox [style.width.px]="240" placeholder="Search User" (valueChange)="onFilter($event)"></kendo-textbox>
      <kendo-grid-spacer></kendo-grid-spacer>
      <!-- Create User -->
      <a [routerLink]="[routesConst.add]" mat-flat-button type="button">
        <mat-icon>add</mat-icon>
        Add User
      </a>
    </ng-template>
    <!-- Columns -->
    <kendo-grid-column field="FirstName" title="First Name"></kendo-grid-column>
    <kendo-grid-column field="LastName" title="Last Name"></kendo-grid-column>
    <kendo-grid-column field="Email" title="Email">
      <ng-template kendoGridCellTemplate let-dataItem>
        <a class="link" [href]="'mailto:' + dataItem.Email">{{ dataItem.Email }}</a>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="" [width]="120">
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- Delete User -->
        <button class="disabled-color" type="button" mat-icon-button [matTooltip]="'Delete User ' + dataItem.Email" (click)="deleteUser(dataItem)">
          <mat-icon class="material-icons-outlined">delete_forever</mat-icon>
        </button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
}
